"use client";

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@repo/ui";
import {
  MEDIA_KINDS,
  MEDIA_KIND_LABELS,
  type MediaKind,
  type MediaLibraryFilter,
} from "@/lib/media-library-filter";

const ALL = "__all__";

interface MediaFacetSelectsProps {
  filter: MediaLibraryFilter;
  counts: Record<MediaKind, number>;
  onSelectKind: (kind?: MediaKind) => void;
}

/** The facet rail folded into the toolbar, for widths that can't spare a column. */
export const MediaFacetSelects = ({ filter, counts, onSelectKind }: MediaFacetSelectsProps) => (
  <Select
    value={filter.kind ?? ALL}
    onValueChange={(value) => onSelectKind(value === ALL ? undefined : (value as MediaKind))}
  >
    <SelectTrigger className="h-8 w-[130px] text-[13px]">
      <SelectValue />
    </SelectTrigger>
    <SelectContent>
      <SelectItem value={ALL} className="text-[13px]">
        All types
      </SelectItem>
      {MEDIA_KINDS.map((kind) => (
        <SelectItem key={kind} value={kind} className="text-[13px]">
          {MEDIA_KIND_LABELS[kind]} ({counts[kind] ?? 0})
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
